import { Route, Routes } from "react-router-dom";
import {
  OpenNotFoundScreen,
  OpenScreen,
} from "../pages/Open/OpenScreen";

export function OpenRoutes() {
  return (
    <Routes>
      <Route index element={<OpenScreen />} />
      <Route path="*" element={<OpenNotFoundScreen />} />
    </Routes>
  );
}
